module.exports = __webpack_public_path__ + "static/media/fsg.5fa19636.svg";